import scriptComponentResolver from './scriptComponentResolver';

export default scriptComponentResolver;
